import { render, staticRenderFns } from "./PhoneCard.vue?vue&type=template&id=5ef8060b&scoped=true&"
import script from "./PhoneCard.vue?vue&type=script&lang=js&"
export * from "./PhoneCard.vue?vue&type=script&lang=js&"
import style0 from "./PhoneCard.vue?vue&type=style&index=0&id=5ef8060b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef8060b",
  null
  
)

export default component.exports